import React, {PureComponent} from 'react';
import pt from 'prop-types';
import cx from 'classnames';

import {CustomPropShapes, logoContainerTypes} from '../../constants';

import styles from './DynamicLogo.pcss';

/**
 * This component takes care of keeping logos within the aspect ratios defined
 * on the design guidelines.
 * It will take an image source and will make sure to add a wrapper around it
 * that automatically specify the right dimensions.
 */

class DynamicLogo extends PureComponent {
    static propTypes = {
        src: pt.string.isRequired,
        alt: pt.string,
        type: CustomPropShapes.oneOfConstant(logoContainerTypes)
    };

    static defaultProps = {
        type: logoContainerTypes.TALL
    };

    state = {
        aspectRatio: 16 / 9,
        hasImageLoaded: false
    };

    _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    // Handle image `onload` behavior for both SSR and client side rendering
    setImageRef = async target => {
        if (!target) return;
        const createLoader = () => {
            return new Promise(resolve => {
                const setLogoAspectRatio = () => {
                    resolve(target.naturalWidth / target.naturalHeight);
                };

                target.onload = setLogoAspectRatio;
                if (target.complete) setLogoAspectRatio();
            });
        };

        await createLoader();

        this.setRatio();
    };

    setRatio = ratio => {
        if (this._isMounted) {
            this.setState({
                hasImageLoaded: true,
                aspectRatio: ratio
            });
        }
    };

    render() {
        const {alt, type, src} = this.props;

        const {aspectRatio, hasImageLoaded} = this.state;

        const tallRatio = aspectRatio <= 1;

        const wrapperClasses = cx(styles.wrapper, styles[`${type}Container`], {
            [styles.visible]: hasImageLoaded,
            [styles.tallRatio]: tallRatio
        });

        return (
            <div className={wrapperClasses}>
                <img className={styles.logo} src={src} alt={alt} ref={this.setImageRef} />
            </div>
        );
    }
}

export default DynamicLogo;
